import React, { useState } from 'react';
import './Flota.css';

// Flota page: contiene tres secciones completas tal como lo solicita el cliente.
export default function Flota({ go }) {
  const [activeStep, setActiveStep] = useState(null);
  return (
    <main className="page page-flota">
      {/* Sección 2: Nuestra Flota de Transporte */}
      <section id="nuestra-flota" className="fleet-section">
        <div className="container">
          <h2 className="section-title">Nuestra Flota de Transporte</h2>

          <p className="fleet-intro">
            Contamos con una flota versátil y confiable, 
            seleccionada estratégicamente para adaptarse al tipo de carga, 
            volumen y nivel de seguridad requerido, 
            garantizando entregas seguras y eficientes tanto en rutas urbanas como a 
            nivel nacional.</p>

          <ul className="fleet-highlights">
            <li>Tipo de camión según la carga</li>
            <li>Capacidad de peso y volumen</li>
            <li>Mantenimiento y condiciones de seguridad</li>
            <li>Mercancía frágil, pesada y urgente</li>
            <li>Rutas urbanas y nacionales</li>
          </ul>

          <div className="catalog-grid" aria-label="Catálogo de camiones">
            {/* Card 1 - Moto para Paquetes Express */}
            <article className="truck-card">
              <div className="truck-image" aria-hidden="true">
                <img src={`${process.env.PUBLIC_URL}/img/flota/motopaqueteria.jpg`} alt="Camión Sencillo" className="truck-photo" />              </div>
              <h3>Moto para Paquetes Express</h3>
              <ul className="specs">
                <li><strong>Capacidad:</strong> hasta 100 kg</li>
                <li><strong>Mercancía:</strong> paquetes, documentos, envíos urgentes</li>
                <li><strong>Uso:</strong> Entregas express urbanas</li>
                <li><strong>Ventaja:</strong> máxima velocidad, evita congestión vial</li>
              </ul>
            </article>

            {/* Card 2 - Van de Carga */}
            <article className="truck-card">
              <div className="truck-image" aria-hidden="true">
                <img src={`${process.env.PUBLIC_URL}/img/flota/vandecarga.jpg`} alt="Camión Sencillo" className="truck-photo" />
              </div>
              <h3>Van de Carga</h3>
              <ul className="specs">
                <li><strong>Capacidad:</strong> hasta 1.5 toneladas</li>
                <li><strong>Uso:</strong> Entregas urbanas y última milla</li>
                <li><strong>Mercancía:</strong> paquetería, documentos, repuestos, e-commerce</li>
                <li><strong>Ventaja:</strong> agilidad, acceso a zonas restringidas y menor costo operativo</li>
              </ul>
            </article>

            {/* Card 3 - Camión Sencillo */}
            <article className="truck-card">
              <div className="truck-image" aria-hidden="true">
                {/* simple truck illustration */}
                <img src={`${process.env.PUBLIC_URL}/img/flota/llanatasencilla.jpg`} alt="Camión Sencillo" className="truck-photo" />
              </div>
              <h3>Camión Sencillo</h3>
              <ul className="specs">
                <li><strong>Capacidad:</strong> 2.5 T</li>
                <li><strong>Mercancía:</strong> Mercancía general, electrodomésticos</li>
                <li><strong>Uso:</strong> Urbano / regional</li>
                <li><strong>Seguridad:</strong> Alto</li>
              </ul>
            </article>

            {/* Card 4 - Camión Carrocería Estacas */}
            <article className="truck-card">
              <div className="truck-image" aria-hidden="true">
                <img src={`${process.env.PUBLIC_URL}/img/flota/Estacas.png`} alt="Camión Sencillo" className="truck-photo" />
              </div>
              <h3>Camión Carrocería Estacas</h3>
              <ul className="specs">
                <li><strong>Capacidad:</strong> 3 – 8 toneladas</li>
                <li><strong>Uso:</strong> Urbano y nacional</li>
                <li><strong>Mercancía:</strong> materiales de construcción, carga paletizada</li>
                <li><strong>Ventaja:</strong> ventilación y facilidad de sujeción de la carga</li>
              </ul>
            </article>

            {/* Card 5 - Camión Turbo */}
            <article className="truck-card">
              <div className="truck-image" aria-hidden="true">
                <img src={`${process.env.PUBLIC_URL}/img/flota/turbo.jpg`} alt="Camión Turbo" className="truck-photo" />
              </div>
              <h3>Camión Turbo</h3>
              <ul className="specs">
                <li><strong>Capacidad:</strong> 6 T</li>
                <li><strong>Mercancía:</strong> Carga general y frágil</li>
                <li><strong>Uso:</strong> Nacional / larga distancia</li>
                <li><strong>Seguridad:</strong> Muy alto</li>
              </ul>
            </article>

            {/* Card 6 - Tractocamión */}
            <article className="truck-card">
              <div className="truck-image" aria-hidden="true">
                <img src={`${process.env.PUBLIC_URL}/img/flota/trailer.jpg`} alt="Camión Sencillo" className="truck-photo" />
              </div>
              <h3>Tractocamión</h3>
              <ul className="specs">
                <li><strong>Capacidad:</strong> 20+ T</li>
                <li><strong>Mercancía:</strong> Pesada / volumétrica</li>
                <li><strong>Uso:</strong> Nacional / larga distancia</li>
                <li><strong>Seguridad:</strong> Máximo</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* MÓDULO NUEVO RECOMENDADO: Proceso de Transporte */}
      <section id="proceso" className="process-section">
        <div className="container">
          <h2 className="section-title">Proceso de Transporte</h2>
          <p className="lead">Nuestro proceso vende confianza: te contamos paso a paso qué sucede después de que cotizas con nosotros.</p>

          <div className="process-container">
            <div className="process-timeline">
              {[
                {
                  id: 1,
                  title: "Recepción de la solicitud",
                  description: "Recibimos tu requerimiento y realizamos un análisis completo de la carga, identificando el tipo de mercancía, condiciones especiales, puntos de origen y destino, y necesidades específicas del servicio para garantizar una operación eficiente desde el inicio.",
                  image: `${process.env.PUBLIC_URL}/img/flota/proceso/1paso.jpg`,
                },
                {
                  id: 2,
                  title: "Planeación logística personalizada",
                  description: "Diseñamos una estrategia logística a la medida, definiendo rutas óptimas, tiempos de entrega y recursos necesarios, con el objetivo de maximizar la eficiencia operativa y minimizar riesgos durante el traslado.",
                  image: `${process.env.PUBLIC_URL}/img/flota/proceso/2paso.jpg`,
                },
                {
                  id: 3,
                  title: "Asignación del vehículo ideal",
                  description: "Seleccionamos el vehículo más adecuado de nuestra flota teniendo en cuenta el peso, volumen, tipo de mercancía y nivel de protección requerido, asegurando un transporte confiable y seguro.",
                  image: `${process.env.PUBLIC_URL}/img/flota/proceso/procesotrans3.jpg`,
                },
                {
                  id: 4,
                  title: "Cargue y aseguramiento de la mercancía",
                  description: "Ejecutamos el proceso de cargue bajo estrictos protocolos técnicos, utilizando métodos de sujeción y protección que garantizan la estabilidad de la carga y previenen daños durante el recorrido.",
                  image: `${process.env.PUBLIC_URL}/img/flota/proceso/3cargueyaseguramiento.jpg`,
                },
                {
                  id: 5,
                  title: "Entrega y confirmación",
                  description: "Realizamos el descargue de manera controlada y verificamos la entrega junto al cliente, confirmando que la mercancía llegue en óptimas condiciones y cumpla con los estándares acordados.",
                  image: `${process.env.PUBLIC_URL}/img/flota/proceso/procesotrans5.jpg`,
                }
              ].map((step) => (
                <article 
                  key={step.id}
                  className={`process-step ${activeStep === step.id ? 'active' : ''}`}
                  onMouseEnter={() => setActiveStep(step.id)}
                  onMouseLeave={() => setActiveStep(null)}
                >
                  <div className="step-number-wrapper">
                    <div className="step-num">{step.id}</div>
                  </div>
                  {activeStep === step.id && (
                    <div className="step-panel">
                      <img src={step.image} alt={step.title} className="panel-image" />
                      <h4>{step.title}</h4>
                      <p>{step.description}</p>
                    </div>
                  )}
                </article>
              ))}
            </div>

            {activeStep === null && (
              <div className="process-default-panel">
                <img src={`${process.env.PUBLIC_URL}/img/flota/proceso/default.png`} alt="Proceso de Transporte" className="default-image" />
              </div>
            )}
          </div>
        </div>
      </section>

      
    </main>
  );
}
 